// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"239":"08772c33","913":"fa8ee874"}[chunkId] + ".chunk.css";
};